import { CloseCircleOutlined, HomeOutlined } from "@ant-design/icons";
import { Button, Card, Typography } from "antd";
import { Link } from "react-router";

const { Title, Paragraph } = Typography;

export default function CancelPayment() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-red-50 to-orange-50 flex items-center justify-center p-4">
      <Card className="max-w-2xl w-full shadow-2xl border-0 rounded-2xl overflow-hidden">
        <div className="text-center py-8">
          <div className="mb-6">
            <CloseCircleOutlined className="text-orange-500 text-8xl animate-pulse" />
          </div>

          <Title level={2} className="text-orange-600 mb-2">
            Payment Cancelled
          </Title>

          <Paragraph className="text-gray-600 text-lg mb-8">
            You have cancelled the payment process.
          </Paragraph>

          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link to="/">
              <Button size="middle" icon={<HomeOutlined />} type="primary">
                Back to Home
              </Button>
            </Link>
          </div>
        </div>
      </Card>
    </div>
  );
}
